import { getMessagesControl } from 'providers/Toast';

export const MESSAGES = getMessagesControl({
  statusChangeAborted: (t) => ({
    title: t('status-change-aborted'),
  }),

  subFormFilling: (t) => ({
    title: t('please-fill-all-fields'),
  }),

  taskDoneWithoutSubsDone: (t) => ({
    title: t('task-still-has-unfinished-subtasks'),
    description: t('make-sure-all-of-them-are-complete-first') as string,
    type: 'error',
  }),

  additionalInfo: (t) => ({
    title: t('theres-still-additional-info-to-be-provided'),
  }),

  existingSubTasks: (t) => ({
    title: t('cant-change-status-to-not-started-if-theres-existing-sub-tasks'),
  }),
});
